import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传图片");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存");

import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { saveRecruitBanner } from '@/request';
import { uploadFile } from '@/request/api';
export default {
  name: 'RecruitBannerModal',
  props: {
    modelValue: Boolean,
    editData: {
      type: Object,
      default: null
    },
    isSee: {
      type: Boolean,
      default: false
    },
    noticeOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const formRef = ref();
    const form = ref({
      bannerId: null,
      imageUrl: '',
      linkRecruitId: null,
      sort: 0,
      startTime: '',
      endTime: ''
    });
    const option = {
      name: 'file',
      action: uploadFile.url
    };
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    watch(() => props.modelValue, val => {
      if (!val) return;

      if (props.editData) {
        var _props$editData$sort;

        form.value = {
          bannerId: props.editData.bannerId,
          imageUrl: props.editData.imageUrl || '',
          linkRecruitId: props.editData.linkRecruitId || null,
          sort: (_props$editData$sort = props.editData.sort) !== null && _props$editData$sort !== void 0 ? _props$editData$sort : 0,
          startTime: props.editData.startTime || '',
          endTime: props.editData.endTime || ''
        };
      } else {
        form.value = {
          bannerId: null,
          imageUrl: '',
          linkRecruitId: null,
          sort: 0,
          startTime: '',
          endTime: ''
        };
      }
    });
    const endTimeRules = [{
      required: true,
      message: '请选择结束时间'
    }, {
      validator: (rule, value, callback) => {
        if (value && form.value.startTime && value <= form.value.startTime) {
          callback(new Error('结束时间必须晚于开始时间'));
          return;
        }

        callback();
      },
      trigger: 'change'
    }];

    function onUploadSuccess(data) {
      if (data.code === 1) {
        form.value.imageUrl = data.data.picUrl || data.data.url || '';
      } else {
        ElMessage.error(data.msg || '上传失败');
      }
    }

    function submit() {
      formRef.value.validate(valid => {
        if (!valid) return;
        saveRecruitBanner(form.value, {
          __repeat: true,
          __warn: true
        }).then(() => {
          ElMessage.success('保存成功');
          visible.value = false;
          emit('success');
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? __props.isSee ? '查看' : '编辑' : '新增',
        width: "560px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), !__props.isSee ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          disabled: __props.isSee,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "排序"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.sort,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.sort = $event),
              min: 0,
              max: 99
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开始时间",
            prop: "startTime",
            rules: {
              required: true,
              message: '请选择开始时间'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: form.value.startTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.startTime = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择开始时间",
              onChange: _cache[2] || (_cache[2] = $event => {
                var _formRef$value;

                return (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validateField('endTime');
              })
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "结束时间",
            prop: "endTime",
            rules: endTimeRules
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: form.value.endTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "Banner图",
            prop: "imageUrl",
            rules: {
              required: true,
              message: '请上传图片'
            }
          }, {
            default: _withCtx(() => [!__props.isSee ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              action: option.action,
              name: option.name,
              "show-file-list": false,
              "on-success": onUploadSuccess
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })]),
              _: 1
            }, 8, ["action", "name"])) : _createCommentVNode("", true), form.value.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
              key: 1,
              src: form.value.imageUrl,
              style: {
                "width": "320px",
                "height": "140px",
                "margin-top": "10px"
              },
              fit: "contain"
            }, null, 8, ["src"])) : _createCommentVNode("", true), !__props.isSee ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 2,
              type: "warning",
              title: "建议尺寸 355*150，jpg/png，不超过 400KB"
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "跳转公告"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.linkRecruitId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkRecruitId = $event),
              clearable: "",
              filterable: "",
              placeholder: "选择招募公告（可选）",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.noticeOptions, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.recruitId,
                  label: item.title,
                  value: item.recruitId
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "disabled"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

};